<template>
    <div>
        <table class="hts-tables">
            <thead class="thead">
                <tr>
                    <th
                        scope="col"
                        class="col">
                        {{ $t('labels.supplyName') }}
                    </th>
                    <th
                        scope="col"
                        class="col">
                        {{ $t('labels.typeSupply') }}
                    </th>
                    <th
                        scope="col"
                        class="col">
                        {{ $t('labels.price') }}
                    </th>
                    <th
                        scope="col"
                        class="col">
                        {{ $t('labels.purchaseTime') }}
                    </th>
                    <th
                        scope="col"
                        class="col">
                        {{ $t('labels.depreciationTime') }}
                    </th>
                    <th
                        scope="col"
                        class="col">
                        <span class="sr-only">
                            {{ $t('labels.edit') }}
                        </span>
                    </th>
                    <th
                        scope="col"
                        class="col">
                        <span class="sr-only">
                            {{ $t('labels.delete') }}
                        </span>
                    </th>
                </tr>
            </thead>
            <tbody class="body">
                <tr
                    v-for="supply in props.listSupplies"
                    :key="supply.id">
                    <td class="col">
                        {{ supply.name }}
                    </td>
                    <td class="col">
                        {{ supply.supplyType?.name }}
                    </td>
                    <td class="col">
                        {{ supply.price }}
                    </td>
                    <td class="col">
                        {{ supply.purchaseTime }}
                    </td>
                    <td class="col">
                        {{ supply.depreciationTime }}
                    </td>
                    <td class="col right">
                        <hts-form-button
                            type="text"
                            color="info"
                            @click="handleEditSupply(supply)">
                            {{ $t('labels.edit') }}
                        </hts-form-button>
                    </td>
                    <td class="col right">
                        <hts-form-button
                            type="text"
                            color="error"
                            @click="handleDeleteSupply(supply)">
                            {{ $t('labels.delete') }}
                        </hts-form-button>
                    </td>
                </tr>
            </tbody>
        </table>

        <hts-modal
            :show="showPopupDeleteSupply"
            :title="$t('labels.deleteDriver')"
            type="confirm"
            :content="$t('labels.confirmDeleteDriver')"
            @hide="closePopupDeleteSupply"
            @confirm="actionDeleteSupply" />
    </div>
</template>

<script setup lang="ts">
const props = defineProps({
  listSupplies: Object
})

const emits = defineEmits(['actionDeleteSupply', 'handleEditSupply'])

const showPopupDeleteSupply = ref(false)
const supplyIsSelectedForDelete = reactive({})

const handleDeleteSupply = (supply: object) => {
  showPopupDeleteSupply.value = true
  Object.assign(supplyIsSelectedForDelete, supply)
}

const actionDeleteSupply = () => {
  const supply = supplyIsSelectedForDelete
  emits('actionDeleteSupply', supply)
  closePopupDeleteSupply()
}

const closePopupDeleteSupply = () => {
  showPopupDeleteSupply.value = false
  Object.assign(supplyIsSelectedForDelete, {})
}

const handleEditSupply = (supply: object) => {
  emits('handleEditSupply', supply)
}
</script>
